import { MARQUEE_ITEMS } from "../../data/content";

export const Marquee = () => {
    const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="relative border-y border-white/8 bg-[#0A0E17]/60 py-5 overflow-hidden"
            aria-hidden="true"
        >
            <div className="animate-marquee flex w-max items-center">
                {items.map((item, i) => (
                    <span key={i} className="flex items-center shrink-0">
                        <span className="font-display text-sm sm:text-base font-semibold uppercase tracking-[0.22em] text-slate-500 px-8">
                            {item}
                        </span>
                        <span className="h-1.5 w-1.5 rotate-45 bg-[#F5C518]/60 shrink-0" />
                    </span>
                ))}
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#07090E] to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#07090E] to-transparent" />
        </div>
    );
};
